import { Component, EventEmitter, Input, Output } from '@angular/core';
import { State } from '../state-view/state.model';

@Component({
  selector: 'app-action-icon',
  templateUrl: './action-icon.component.html',
  styleUrls: ['./action-icon.component.scss'],
  host: {
    'class': 'action-icon'
  }
})
export class ActionIconComponent {
  @Input() value: any;
  @Input() state: State;
  @Output() toggle = new EventEmitter<any>();
  hover = false;

  onClick($event: MouseEvent) {
    this.toggle.emit(this.value);
    $event.preventDefault();
    $event.stopPropagation();
  }

  mouseEnter() {
    this.hover = true;
  }

  mouseLeave() {
    this.hover = false;
  }
}
